/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Out_Reason_DiscardInputs */

const vi_pkl_out_reason_discard = /** @type {(inputs: Pkl_Out_Reason_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy`)
};

/**

* @param {Pkl_Out_Reason_DiscardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_out_reason_discard = /** @type {((inputs?: Pkl_Out_Reason_DiscardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Out_Reason_DiscardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_out_reason_discard(inputs)
});